import React from 'react';
import styles from './styles.module.scss';

interface PopupProps {
	isOpen: boolean;
	onClose: () => void;
	children: React.ReactNode;
}

const Popup: React.FC<PopupProps> = ({ isOpen, onClose, children }) => {
	if (!isOpen) return null;

	const handleOverlayClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return (
		<button
			type="button"
			className={styles['popup']}
			onClick={handleOverlayClick}
			onKeyDown={e => {
				if (e.key === 'Escape') {
					onClose();
				}
			}}
			aria-label="Close popup overlay"
		>
			<div className={styles['popup-content']}>
				<button className={styles['close']} onClick={onClose} type="button" aria-label="Close popup">
					&times;
				</button>
				{children}
			</div>
		</button>
	);
};

export default Popup;
